/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { format } from "date-fns";
import { useI18n } from "hooks/i18n/i18n";
import { Link } from "react-router-dom";
import { getPaymentStatus } from "utility/getPaymentStatus";
import { getPaymentType } from "utility/getPaymentType";

import { PAYMENT_STATUS } from "../../constants/paymentStatus";
import {
  arrowIconStyle,
  bottomContentsStyle,
  bottomLeftContentsStyle,
  countBadgeStyle,
  dateStyle,
  headerStyle,
  imageStyle,
  imageWrapperStyle,
  orderNumberStyle,
  rightContentsStyle,
  rootStyle,
  settlementStatusStyle,
  settlementStatusUnpaidStyle,
} from "./styles";

import type { Props } from "./props";
import type { FC } from "react";

export const HistoryCard: FC<Props> = (props) => {
  const {
    imagePath,
    label,
    orderId,
    paymentStatus,
    paymentType,
    purchasedAt,
    purchasedCount,
  } = props;

  const { t } = useI18n();

  return (
    <Link
      css={rootStyle}
      // TODO: 限定公開が不要になったら削除する
      // https://github.com/balus-co-ltd/spwn/issues/10899
      to={`/account/settlement/history/${orderId}?newPurchaseHistory`}
    >
      <div css={imageWrapperStyle}>
        {purchasedCount > 1 && (
          <div css={countBadgeStyle}>{purchasedCount}</div>
        )}

        <img
          alt={""}
          css={imageStyle}
          height={"113px"}
          src={imagePath}
          width={"113px"}
        />
      </div>

      <div css={rightContentsStyle}>
        <header css={headerStyle}>
          <time css={dateStyle} dateTime={new Date(purchasedAt).toISOString()}>
            {format(new Date(purchasedAt), "yyyy/MM/dd")}
          </time>

          {label}
        </header>

        <div css={bottomContentsStyle}>
          <div css={bottomLeftContentsStyle}>
            <p css={orderNumberStyle}>
              {t("settlementHistory.orderNumber")} :{orderId}
            </p>

            <p css={settlementStatusStyle}>
              {t(getPaymentType(paymentType))} :
              <span
                css={
                  paymentStatus !== PAYMENT_STATUS.PAYSUCCESS
                    ? settlementStatusUnpaidStyle
                    : undefined
                }
              >
                {t(getPaymentStatus(paymentStatus))}
              </span>
            </p>
          </div>

          <div css={arrowIconStyle}>
            <KeyboardArrowRightIcon fontSize="small" />
          </div>
        </div>
      </div>
    </Link>
  );
};
